/** Проверить, является ли сущность функцией */
export const isFunction = <F extends (...params: never[]) => void>(target: unknown): target is F =>
    typeof target === 'function';
